import type { ListMetaData, Option } from './types';

export type FilterOptionMap = {
  options: Record<string, Option[]>;
};

export const getFilterOptionMapFromMetaData = (
  metadata?: ListMetaData
): FilterOptionMap | undefined => {
  if (!metadata) {
    return;
  }

  const { filters } = metadata;

  if (!filters) {
    return;
  }

  const options: FilterOptionMap['options'] = {};

  filters.forEach(f => {
    options[f.field_name] =
      Object.entries(f.options).map(([key, value]) => ({
        label: value,
        value: key
      })) ?? [];
  });

  return {
    options
  };
};

/**
 * The fields a list endpoint accepts as `sort_by`, as a set so a table can ask
 * whether a column key is sortable. `undefined` when the response carries no
 * metadata, mirroring `getFilterOptionMapFromMetaData`, so a caller can tell a
 * missing list from an empty one and fall back to its own stable empty set.
 */
export const getSortableFieldsFromMetaData = (
  metadata?: ListMetaData
): Set<string> | undefined =>
  metadata?.sort_by ? new Set(metadata.sort_by) : undefined;
